document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuPanel = document.querySelector('[data-menu-panel]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');

  menuToggle?.addEventListener('click', () => menuPanel?.classList.toggle('is-open'));
  searchToggle?.addEventListener('click', () => {
    searchPanel?.classList.toggle('is-open');
    searchPanel?.querySelector('input')?.focus();
  });

  const countdown = document.querySelector('[data-countdown]');
  if (countdown) {
    const end = Date.now() + 1000 * 60 * 60 * 23 + 1000 * 60 * 47;
    setInterval(() => {
      const remaining = Math.max(0, end - Date.now());
      const h = Math.floor(remaining / 3600000);
      const m = Math.floor((remaining % 3600000) / 60000);
      const s = Math.floor((remaining % 60000) / 1000);
      countdown.innerHTML = `D <b>00</b> H <b>${String(h).padStart(2, '0')}</b> M <b>${String(m).padStart(2, '0')}</b> S <b>${String(s).padStart(2, '0')}</b>`;
    }, 1000);
  }

  document.querySelectorAll('.product-panel fieldset input[type="radio"]').forEach((input) => {
    input.addEventListener('change', () => {
      const form = input.closest('form');
      const select = form?.querySelector('.variant-select');
      if (!form || !select) return;
      const chosen = Array.from(form.querySelectorAll('fieldset')).map((set) => set.querySelector('input:checked')?.value).filter(Boolean).join(' / ');
      const match = Array.from(select.options).find((option) => option.textContent.trim().startsWith(chosen));
      if (match) select.value = match.value;
    });
  });
});
